import {
	GET_TYPEAHEAD_END,
	GET_TYPEAHEAD_START,
	Actions
} from "../actions";
import { TYPEAHEAD_SEARCH_VALUES } from "../config";
import { safe, appendToLoading, removeFromLoading, isNullOrUndefined } from "../utils";
import { IDataEntity, IToggleRequest, ILoading, ITypeahead } from "../models";

export function typeaheadReducer(state: IDataEntity[] = null, action: Actions) {
	switch (action.type) {
		case GET_TYPEAHEAD_END:
			let response = [];
			let typeheadObj: ITypeahead;
			let shareTypePattern = new RegExp(/{shareTypeAbbreviation}/g);
			let shareLetterpattern = new RegExp(/{shareclassLetter}/g);

			for (let fund of action.payload.values) {
				for (let share of fund.shareClasses) {
					if (!isNullOrUndefined(share.properties.shareclass_display)) {
						share.properties.shareclass_display = share.properties.shareclass_display.toString().replace(shareTypePattern, "").replace(shareLetterpattern, "");
					}
					let typeheadResponse = Object.assign({}, typeheadObj);
					let typeheadvalues = [];

					for (let typeaheadSearch of TYPEAHEAD_SEARCH_VALUES) {
						if (!isNullOrUndefined(share.properties[typeaheadSearch])) {
							typeheadvalues.push(share.properties[typeaheadSearch]);
						}
					}

					let searchable = typeheadvalues.map(item => item.trim()).filter(item => item !== "").join("|");
					let candidateTerms = searchable.split("|");
					let isin = candidateTerms.shift().toUpperCase();
					let fundName = candidateTerms.shift().toUpperCase();
					let termCombinations = [isin, fundName];
					for (let candidate of candidateTerms) {
						termCombinations.push(`${ fundName } ${ candidate.toUpperCase() } ${ candidateTerms.filter(ct => ct !== candidate).join(" ").toUpperCase() }`);
					}

					typeheadResponse.display = { ...share.properties, ...fund.properties };
					typeheadResponse.isin = safe(() => share.properties.isin, "");
					typeheadResponse.searchable = termCombinations.join("|");

					response.push(typeheadResponse);
				}
			}

			return response;
		default: return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/typeahead.ts